<script setup lang="ts">
import HeightTransition from '@/shared/components/transitions/HeightTransition.vue'
import CaretIcon from '../icon/CaretIcon.vue'

interface Props {
  label: string
}

interface Emits {
  (e: 'click'): void
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const model = defineModel<boolean>({ required: true })

const onToggle = (): void => {
  model.value = !model.value

  emit('click')
}
</script>

<template>
  <div class="flex items-center px-2" v-bind="$attrs">
    <div class="cursor-pointer" @click="onToggle">
      <span class="text-sm dark:text-gray-400" :class="model ? ' text-brand' : 'text-gray-700'">
        {{ label }}
      </span>
    </div>
    <div class="flex-1 border-t border-gray-200 dark:border-gray-800 ms-2"></div>
    <slot name="toolbar"></slot>
    <div class="flex border border-gray-200 cursor-pointer">
      <CaretIcon :active="model" class="fill-gray-700 h-5 w-5" @click="onToggle" />
    </div>
  </div>
  <HeightTransition>
    <div v-show="model" class="px-3 mt-1">
      <slot></slot>
    </div>
  </HeightTransition>
</template>
